/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

function RadialGaugeViewChart({ value }: any) {
  const [state, setState] = useState<any>({
    series: [0],
    options: {
      chart: {
        type: "radialBar",
        offsetY: -20,
        sparkline: {
          enabled: true,
        },
      },
      plotOptions: {
        radialBar: {
          startAngle: -90,
          endAngle: 90,
          track: {
            background: "#e7e7e7",
            strokeWidth: "97%",
            margin: 5, // margin is in pixels
            dropShadow: {
              enabled: true,
              top: 2,
              left: 0,
              color: "#444",
              opacity: 1,
              blur: 2,
            },
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              offsetY: -2,
              fontSize: "22px",
            },
          },
        },
      },
      grid: {
        padding: {
          top: -10,
        },
      },
      fill: {
        colors: ["#044040"],
      },
      labels: ["Average Results"],
    },
  });

  useEffect(() => {
    if (value) {
      setState((prevState: any) => ({
        ...prevState,
        series: [value],
      }));
    }
  }, [value]);

  return (
    <ReactApexChart
      options={state.options}
      series={state.series}
      type="radialBar"
    />
  );
}

export default RadialGaugeViewChart;
